import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertCircle, Loader } from 'lucide-react';
import { testSupabaseConnection } from '../../lib/supabase';

const PlatformStatusIndicator = () => {
  const [status, setStatus] = useState('checking'); // 'checking' | 'ok' | 'error'

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const result = await testSupabaseConnection();
        if (!cancelled) {
          setStatus(result?.ok ? 'ok' : 'error');
        }
      } catch (err) {
        if (!cancelled) setStatus('error');
      }
    };
    check();
    // Re-check every 2 minutes
    const interval = setInterval(check, 120000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, []);

  if (status === 'checking') {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 bg-gray-50 border border-gray-200 rounded-full">
        <Loader className="w-3 h-3 text-gray-400 animate-spin" />
        <span className="text-xs text-gray-500">Checking...</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center gap-1.5 px-3 py-1.5 bg-yellow-50 border border-yellow-200 rounded-full">
        <AlertCircle className="w-3 h-3 text-yellow-500" />
        <span className="text-xs text-yellow-700">Limited connectivity</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 border border-green-200 rounded-full">
      <CheckCircle className="w-3 h-3 text-green-500" />
      <span className="text-xs text-green-700">All systems operational</span>
    </div>
  );
};

export default PlatformStatusIndicator;